<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout v-show="ready" :show-background="true" container-class="max-w-sm px-4 py-10">
            <div v-if="ready && loading == false">
                <h1 class="mb-4 text-xl font-bold leading-tight text-center text-highlight-100">
                    {{ _('rental_title') }}
                </h1>

                <h1 v-if="!tvodExists || plans.length === 0" class="mb-4 text-xl font-bold leading-tight text-center text-highlight-100">
                    Rental is not available for this title
                </h1>

                <template v-if="tvodExists && plans.length > 0">
                    <RentalCard
                        v-for="plan in plans"
                        :key="plan.uuid"
                        :show="show"
                        :pack="plan.entitlement"
                        :plan="plan"
                        class="mb-8"
                        @selected="select(plan.external_id, plan)"
                    />
                </template>

                <StickyFooter>
                    {{ _(`${this.provider.name.toLowerCase()}_pack_disclaimer_1`) }}
                    {{ _(`${this.provider.name.toLowerCase()}_pack_disclaimer_2`) }}
                    {{ _(`${this.provider.name.toLowerCase()}_pack_disclaimer_3`) }}
                </StickyFooter>
            </div>

            <Portal to="spinner">
                <div v-if="loading"
                     class="fixed inset-0 flex flex-col items-center justify-center p-8 bg-background-80">
                    <div class="mb-20">
                        <BaseSpinner/>
                    </div>
                </div>
            </Portal>
        </Layout>
    </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'
import BaseSpinner from '@/components/Base/BaseSpinner.vue'
import RentalCard from '@/components/Plan/RentalCard.vue'
import StickyFooter from '@/components/StickyFooter.vue'

export default {
    name: 'Rental',
    components: {
        Layout,
        RentalCard,
        BaseSpinner,
        StickyFooter,
    },
    data() {
        return {
            ready: false,
            loading: false,
        }
    },
    computed: {
        ...mapState({
            show: (state) => state.vod.show,
            tvodExists: (state) => state.vod.show.tvod !== false,
            plans: (state) => Object.values(state.rentals.plans),
        }),
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            provider: 'providers/selected',
            params: 'settings/get',
            chargeStatus: 'charge/status',
        }),
        title() {
            return this.$router.currentRoute.name
        },
        rentalConfig() {
            return this.show.tvod.filter(
                (config) => config.name.toLowerCase() === this.provider.name.toLowerCase(),
            ).shift()
        },
    },
    methods: {
        select(id, plan) {
            this.$store.dispatch('packs/select', id)
                .then(() => {
                    const pack = { plans: [plan] }
                    this.$store.dispatch('packs/setPack', pack)
                    this.$router.push({ name: 'Continue' })
                })
        },
    },
    created() {
        NProgress.start()
        this.loading = true

        // reset any complete/failed purchases
        if (this.chargeStatus !== 'PENDING') {
            this.$store.dispatch('packs/reset')
            this.$store.dispatch('charge/reset')
        }

        this.$store.dispatch('vod/fetch', {
            key: this.params.api_key,
            uvid: this.params.uvid,
            cc: this.params.cc,
            lang: this.params.lang,
        }).then(() => { // a valid vod is a prerequisite to fetch the associated pack
            if (!this.tvodExists) {
                this.loading = false

                return
            }

            const { plans } = this.rentalConfig;

            for (let index = 0; index < plans.length; index += 1) {
                this.$store.dispatch('rentals/fetch', {
                    key: this.params.api_key,
                    companyUuid: this.params.company_uuid,
                    providerUuid: this.provider.uuid,
                    planUuid: this.rentalConfig.plans[index].uuid ?? 'unavailable',
                    platform: this.params.platform,
                    cc: this.params.cc,
                })
            }

            this.loading = false
        })
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
    },
}
</script>
